import React from "react";
import Section from "../components/Section";
import { Button, IconButton, List, Typography } from "../components";
import Modal from "../components/Modal/Modal";
import ModalWrapper from "../components/Modal/ModalWrapper";
import { Trash } from "@phosphor-icons/react";

const DialogSection = () => {
	const [state, setState] = React.useState({
		modal1: false,
		modal2: false,
		modal3: false,
		modal4: false,
		modal5: false,
		modal6: false,
		modal7: false
	});
	const handleClick = (key: any) => {
		setState({ ...state, [key]: true });
	};
	const handleClose = (event: any) => {
		console.log("event", event);
		setState({ ...state, [event]: false });
	};

	return (
		<Section className="w-100" title={"# Dialogs"}>
			<div className="d-flex gap1 w-100">
				<div className="d-flex">
					<Button
						buttonType="button"
						label="Simple Dialog"
						onClick={() => handleClick("modal1")}
						size="medium"
						variant="tertiary"
						name="modal1"
					/>
					<Modal open={state.modal1} handleClose={handleClose} modalStyles={{}} modalName={"modal1"} enableBackdrop={true}>
						<ModalWrapper
							alignment="center"
							featuredIcon={
								<IconButton className="border-rounded" buttonType="button" onClick={() => {}} size="medium" variant="tertiary">
									<Trash size={"1.5rem"} />
								</IconButton>
							}
							handleClose={() => handleClose("modal1")}
							handleSubmit={() => {
								console.log("submit");
							}}
						>
							<Typography type="heading">This is modal title</Typography>
							<Typography type="text">This is modal body</Typography>
							<Typography type="text">This is modal body</Typography>
							<Typography type="text">This is modal body</Typography>
						</ModalWrapper>
					</Modal>
				</div>
			</div>
			<div className="d-flex gap1 w-100">
				<div className="d-flex">
					<Button
						buttonType="button"
						label="Modal without backdrop"
						onClick={() => handleClick("modal2")}
						size="medium"
						variant="tertiary"
						name="modal2"
					/>
					<Modal open={state.modal2} handleClose={handleClose} modalStyles={{}} modalName={"modal2"} enableBackdrop={false}>
						<ModalWrapper
							alignment="center"
							featuredIcon={
								<IconButton className="border-rounded" buttonType="button" onClick={() => {}} size="medium" variant="tertiary">
									<Trash size={"1.5rem"} />
								</IconButton>
							}
							handleClose={() => handleClose("modal2")}
						>
							<Typography type="heading">Without backdrop</Typography>
						</ModalWrapper>
					</Modal>
				</div>
			</div>
			<div className="d-flex gap1 w-100">
				<div className="d-flex">
					<Button
						buttonType="button"
						label="Modal without footer"
						onClick={() => handleClick("modal3")}
						size="medium"
						variant="tertiary"
						name="modal3"
					/>
					<Modal open={state.modal3} handleClose={handleClose} modalStyles={{}} modalName={"modal3"} enableBackdrop={true}>
						<ModalWrapper
							alignment="center"
							featuredIcon={
								<IconButton className="border-rounded" buttonType="button" onClick={() => {}} size="medium" variant="tertiary">
									<Trash size={"1.5rem"} />
								</IconButton>
							}
							handleClose={() => handleClose("modal3")}
							hideFooter={true}
						>
							<Typography type="heading">Without backdrop</Typography>
						</ModalWrapper>
					</Modal>
				</div>
			</div>
			<div className="d-flex gap1 w-100">
				<div className="d-flex">
					<Button
						buttonType="button"
						label="Modal without featured icon"
						onClick={() => handleClick("modal4")}
						size="medium"
						variant="tertiary"
						name="modal4"
					/>
					<Modal open={state.modal4} handleClose={handleClose} modalStyles={{}} modalName={"modal4"} enableBackdrop={true}>
						<ModalWrapper alignment="center" handleClose={() => handleClose("modal4")}>
							<Typography type="heading">Modal without featured icon</Typography>
						</ModalWrapper>
					</Modal>
				</div>
			</div>
			<div className="d-flex gap1 w-100">
				<div className="d-flex">
					<Button
						buttonType="button"
						label="Modal without Close icon"
						onClick={() => handleClick("modal6")}
						size="medium"
						variant="tertiary"
						name="modal6"
					/>
					<Modal open={state.modal6} handleClose={handleClose} modalStyles={{}} modalName={"modal6"} enableBackdrop={true}>
						<ModalWrapper alignment="center" hideCloseButton={true} handleClose={() => handleClose("modal6")}>
							<Typography type="heading">Modal without featured icon</Typography>
						</ModalWrapper>
					</Modal>
				</div>
			</div>
			<div className="d-flex gap1 w-100">
				<div className="d-flex">
					<Button
						buttonType="button"
						label="Modal without Header"
						onClick={() => handleClick("modal5")}
						size="medium"
						variant="tertiary"
						name="modal5"
					/>
					<Modal open={state.modal5} handleClose={handleClose} modalStyles={{}} modalName={"modal5"} enableBackdrop={true}>
						<ModalWrapper alignment="center" hideHeader={true} handleClose={() => handleClose("modal5")}>
							<Typography type="heading">Modal without featured icon</Typography>
						</ModalWrapper>
					</Modal>
				</div>
			</div>
			<div className="d-flex gap1 w-100">
				<div className="d-flex">
					<Button
						buttonType="button"
						label="Modal without wrapper"
						onClick={() => handleClick("modal7")}
						size="medium"
						variant="tertiary"
						name="modal7"
					/>
					<Modal open={state.modal7} handleClose={handleClose} modalStyles={{}} modalName={"modal7"} enableBackdrop={true}>
						<Typography type="heading">Modal without wrapper</Typography>
					</Modal>
				</div>
			</div>
		</Section>
	);
};

export default DialogSection;
